module.exports = __webpack_public_path__ + "static/media/card-customer-icon.9f8dd1dc.svg";